import React from 'react';
import styled from 'styled-components';
import { ImSpinner2 } from 'react-icons/im';

const variants = {
  primary: {
    background: '#4654A3',
    color: '#FFFFFF',
    hoverBackground: '#24286B',
  },
  secondary: {
    background: '#FFFFFF',
    color: '#24286B',
    hoverBackground: '#24286B',
    border: '1px solid #24286B',
  },
};

const sizes = {
  large: {
    height: '56px',
    padding: '8px 24px',
    fontSize: '16px',
    iconSize: 20,
  },
  small: {
    height: '40px',
    padding: '4px 16px',
    fontSize: '14px',
    iconSize: 16,
  },
};

const Spinner = styled(ImSpinner2)`
  animation: spin 1s linear infinite;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  font-weight: 600;
  border: ${(props) => variants[props.$variant].border || 'none'};
  background-color: ${(props) => variants[props.$variant].background};
  color: ${(props) => variants[props.$variant].color};
  height: ${(props) => sizes[props.$size].height};
  padding: ${(props) => sizes[props.$size].padding};
  font-size: ${(props) => sizes[props.$size].fontSize};
  width: fit-content;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: all 250ms cubic-bezier(0.2, 0, 1, 1.1);
  z-index: 1;

  &:hover {
    background-color: ${(props) =>
      !props.disabled && variants[props.$variant].hoverBackground};
  }

  &:active {
    transform: ${(props) => (!props.disabled ? 'scale(0.98)' : 'none')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default function Button({
  label = 'Button',
  variant = 'primary',
  size = 'large',
  onClick,
  iconLeft,
  iconRight,
  loading = false,
}) {
  const iconSize = sizes[size].iconSize;

  return (
    <StyledButton
      $variant={variant}
      $size={size}
      onClick={onClick}
      disabled={loading}
    >
      {loading ? (
        <Spinner size={iconSize} />
      ) : (
        <>
          {iconLeft && <span>{React.cloneElement(iconLeft, { size: iconSize })}</span>}
          {label}
          {iconRight && <span>{React.cloneElement(iconRight, { size: iconSize })}</span>}
        </>
      )}
    </StyledButton>
  );
}